import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface LogoProps {
  showText?: boolean;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  href?: string;
  subtitle?: string;
}

export function Logo({ showText = true, size = "md", className, href = "/", subtitle }: LogoProps) {
  const sizeClasses = {
    sm: {
      icon: "h-7 w-7",
      text: "text-lg",
      subtitle: "text-[10px]",
      ligature: "text-base",
    },
    md: {
      icon: "h-9 w-9",
      text: "text-2xl",
      subtitle: "text-xs",
      ligature: "text-lg",
    },
    lg: {
      icon: "h-12 w-12",
      text: "text-3xl",
      subtitle: "text-sm",
      ligature: "text-2xl",
    },
    xl: {
      icon: "h-16 w-16",
      text: "text-4xl",
      subtitle: "text-base",
      ligature: "text-3xl",
    },
  };

  const sizes = sizeClasses[size];

  const logoContent = (
    <div className={cn("flex items-center gap-3 group", className)}>
      <div className={cn("flex items-center justify-center rounded bg-primary transition-all duration-300 ease-out group-hover:scale-110 group-hover:rotate-3 group-hover:shadow-lg group-hover:shadow-primary/30", sizes.icon)}>
        <span className={cn("font-serif font-semibold text-primary-foreground transition-transform duration-300 group-hover:scale-110", sizes.ligature)}>
          Ã†
        </span>
      </div>
      {showText && (
        <div className="transition-transform duration-300 ease-out group-hover:translate-x-1">
          <span className={cn("font-serif font-medium tracking-tight text-foreground", sizes.text)}>
            Aegis
          </span>
          {subtitle && (
            <p className={cn("text-muted-foreground", sizes.subtitle)}>{subtitle}</p>
          )}
        </div>
      )}
    </div>
  );

  if (href) {
    return (
      <Link to={href} className="transition-opacity hover:opacity-80">
        {logoContent}
      </Link>
    );
  }

  return logoContent;
}
